import { render, staticRenderFns } from "./PostComponent.vue?vue&type=template&id=c522526c&scoped=true&"
import script from "./PostComponent.vue?vue&type=script&lang=js&"
export * from "./PostComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostComponent.vue?vue&type=style&index=0&id=c522526c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522526c",
  null
  
)

export default component.exports